import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation UploadChatAttachment($id: ID!, $input: UploadChatAttachmentInput!) {
    uploadChatAttachment(id: $id, input: $input) {
      writeUrl
      readUrl
      maxBytes
      acl
    }
  }
`);
